import { render, staticRenderFns } from "./CreateSingleProductDashboard.vue?vue&type=template&id=39c798c8&scoped=true&"
import script from "./CreateSingleProductDashboard.vue?vue&type=script&lang=js&"
export * from "./CreateSingleProductDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CreateSingleProductDashboard.vue?vue&type=style&index=0&id=39c798c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c798c8",
  null
  
)

export default component.exports